import React from 'react';
import PropTypes from 'prop-types';
import { TextField, MenuItem } from '@mui/material';
import DescribedField from '../DescribedField';
import LogoUploadField from '../LogoUploadField';

/**
 * HeroBlockEditor — Editor do bloco Capa (Hero)
 * TODO 4.5
 *
 * Props:
 *   - value: { title, subtitle, imageUrl, avatarShape }
 *   - onChange: (patch) => void
 *   - context: { siteType, scope, availableProfessionals, ... }
 */
const HeroBlockEditor = ({ value = {}, onChange, context = {} }) => {
  const {
    title = '',
    subtitle = '',
    imageUrl = '',
    avatarShape = 'round',
  } = value;

  const patch = (field, val) => onChange({ ...value, [field]: val });

  return (
    <>
      <DescribedField
        label="Título"
        description="Aparece como primeiro texto da página. Use o nome do profissional, da clínica ou um título comercial (ex.: 'Consultório Dr. João Silva'). Máx. 80 caracteres."
      >
        <TextField
          fullWidth
          value={title}
          onChange={(e) => patch('title', e.target.value)}
          inputProps={{ maxLength: 80 }}
          placeholder="Ex.: Dr. João Silva"
          size="small"
        />
      </DescribedField>

      <DescribedField
        label="Subtítulo"
        description="Linha de apoio logo abaixo do título. Use para especialidade, slogan ou posicionamento (ex.: 'Dermatologia Clínica e Estética'). Máx. 140 caracteres."
      >
        <TextField
          fullWidth
          value={subtitle}
          onChange={(e) => patch('subtitle', e.target.value)}
          inputProps={{ maxLength: 140 }}
          placeholder="Ex.: Dermatologia Clínica e Estética"
          size="small"
        />
      </DescribedField>

      <DescribedField
        label="Imagem principal"
        description="Foto ou imagem principal exibida na capa. Em páginas profissionais, sugerimos usar a foto cadastrada em Profissionais. Para trocar a foto oficial, edite em Profissionais; para usar outra imagem só aqui, faça upload abaixo."
        helperLink={context.siteType === 'professional_site' ? { entity: 'professional' } : undefined}
      >
        <LogoUploadField
          value={imageUrl}
          onChange={(url) => patch('imageUrl', url)}
        />
      </DescribedField>

      <DescribedField
        label="Formato da imagem"
        description="Formato da imagem de capa. 'Redondo' é ideal para foto pessoal. 'Livre' preserva proporções originais — melhor para banners ou logos. A escolha impacta o visual imediatamente."
      >
        <TextField
          select
          fullWidth
          value={avatarShape}
          onChange={(e) => patch('avatarShape', e.target.value)}
          size="small"
        >
          <MenuItem value="round">Redondo</MenuItem>
          <MenuItem value="free">Livre</MenuItem>
        </TextField>
      </DescribedField>
    </>
  );
};

HeroBlockEditor.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    imageUrl: PropTypes.string,
    avatarShape: PropTypes.oneOf(['round', 'free']),
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.shape({
    siteType: PropTypes.string,
    scope: PropTypes.object,
    availableProfessionals: PropTypes.array,
    availablePlaces: PropTypes.array,
    availableSchedules: PropTypes.array,
    availableServices: PropTypes.array,
  }),
};

export default HeroBlockEditor;
